var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasListManagement && _vm.hasPermission('vp.cockpit.managereports.show'))?_c('div',{staticClass:"flex py-2 px-4 cursor-pointer",staticStyle:{"position":"absolute","bottom":"5px","left":"5px"},on:{"click":function($event){_vm.$router.push({ name: 'cp-reports' }).catch(() => {})}}},[_c('feather-icon',{class:{
      'text-white': this.$store.state.themeProps.theme === 'semi-dark',
    },attrs:{"icon":"SettingsIcon","svgClasses":"w-4 h-4"}}),_c('span',{staticClass:"semi-bold",class:{
      'text-white': this.$store.state.themeProps.theme === 'semi-dark',
    }},[_vm._v("Manage reports")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }